import React from 'react';


export default function Footer(props) {
    return (
        <div className="row">
            <div className={"col-md-6"}>
          
            </div>

            <div className="col-md-6 pt-10">

                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Total Detalle</label>
                        <div>{props.onGetFieldValue('sumaTotalDetalle').toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Sub Total</label>
                        <div>{props.onGetFieldValue('sumaSubTotal').toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Igv</label>
                        <div>{Math.abs(props.onGetFieldValue('sumaIgv').toFixed(2))}</div>
                    </div>
                </div>

                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Total</label>
                        <div>{props.onGetFieldValue('sumaTotal').toFixed(2)}</div>
                    </div>
                </div>



            </div>
        </div>
    );
}